import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { filingRejectReasonAPI } from '../../utilities/api/filingRejectReasonApi';

// represents the shape of the slice in state
interface FilingRejectReasonState {
  value: any[];
}

const initialState: FilingRejectReasonState = {
  value: [],
};

const filingRejectReasonSlice = createSlice({
  name: 'stateFilingRejectReason',
  initialState,
  reducers: {
  },
  extraReducers(builder) {
    builder.addCase(getAllFilingRejectReasons.fulfilled, (state, action) => {
      state.value = action.payload;
    });
  },
});

// Async thunk to fetch data from api
// under extra reducers on fulfilled the redux store is updated
export const getAllFilingRejectReasons = createAsyncThunk('stateFilingRejectReason/getAllFilingRejectReasons', async () => {
  const response = await filingRejectReasonAPI.getFilingRejectReasons();
  return response;
});

export default filingRejectReasonSlice.reducer;
